import React from 'react';
import RoadsBillSummary from './RoadsBillSummary';

export { CARRIAGEWAY_SUMMARY_SECTION_KEYS } from './RoadsBillSummary';

interface CarriagewaySummaryProps {
  showHeader?: boolean;
  noPadding?: boolean;
  expandedRowKeys?: React.Key[];
  onExpandedRowKeysChange?: (keys: React.Key[]) => void;
  stickyOffset?: number;
}

const CarriagewaySummary: React.FC<CarriagewaySummaryProps> = (props) => (
  // hideZeroQtyRows=false: this is the take-off page's own tab, where the estimator
  // needs to see every possible line item while entering data, not just the ones
  // already populated — unlike /roads-sewers/review's Bill Summary (RoadsBillSummary's
  // own default), which hides unpopulated rows to keep the final summary uncluttered.
  <RoadsBillSummary showRateAmount={false} hideZeroQtyRows={false} {...props} />
);

export default CarriagewaySummary;
